import Vue from "vue"

// 全局过滤器， formatDate 专门过滤日期
Vue.filter("formatDate",value=>{
    return value && new Date(value).toLocaleDateString().replaceAll("/","-");
})